import Cookie from '@/utils/cookie'
import Consts from '@/common/consts'
import { getDefaultUserInfo } from '@/utils/help'
const u = Cookie.get(Consts.COOKIE_USER_INFO) ? JSON.parse(Cookie.get(Consts.COOKIE_USER_INFO)) : ''
export default {
  jsUrl: '',
  navigationTitle: '',
  fromSourceUrl: '',
  authTbAccountName: Cookie.get(Consts.COOKIE_AUTH_TB_ACCOUNT_NAME),
  authTbAccountRelationId: Cookie.get(Consts.COOKIE_AUTH_TB_ACCOUNT_RELATION_ID),
  mobile: Cookie.get(Consts.COOKIE_USER_MOBILE),
  token: Cookie.get(Consts.COOKIE_USER_TOKEN),
  userUnionID: Cookie.get(Consts.COOKIE_USER_UNIONID),
  userInfo: u || getDefaultUserInfo(),
}
